import { Link, Navigate, createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { Trans, useTranslation } from "react-i18next";

import { api } from "../../convex/_generated/api";
import { PaneHeader } from "@/components/settings/frame";
import { roleName } from "@/components/studio-console/format";
import { StatusChip } from "@/components/studio-console/shared";
import { Button } from "@/components/ui/button";

/**
 * The design studio the person is in: how Ours' review went, how many are in
 * it, their role, and the console when their role opens it. The team itself
 * is managed in the console (/studio/console).
 */
export const Route = createFileRoute("/settings/studio")({
  component: StudioPage,
});

function StudioPage() {
  const { t } = useTranslation("studio");
  const companies = useQuery(api.organizations.mine);
  if (companies === undefined) return null;
  const studio = companies.find((c) => c.kind === "studio");
  if (!studio) return <Navigate to="/settings" replace />;
  return (
    <div>
      <PaneHeader
        title={<Trans t={t} i18nKey="settings.title" values={{ name: studio.name }} components={{ em: <em className="italic" /> }} />}
        description={t("settings.body")}
      />
      <div className="grid gap-3 border-t border-line-strong pt-6">
        <div className="flex flex-wrap items-center gap-2.5">
          <StatusChip status={studio.status} />
          <span className="text-sm text-ink-3">
            {t("settings.people", { count: studio.people })} · {t("settings.role", { role: roleName(t, studio.role) })}
          </span>
        </div>
        {studio.status === "pending" ? <p className="text-sm text-ink-2">{t("settings.pending")}</p> : null}
        {studio.status === "rejected" ? (
          <p className="text-sm text-ink-2">{t("settings.rejected", { reason: studio.rejectedBecause ?? "" })}</p>
        ) : null}
        {studio.keys.includes("console") ? (
          <Button variant="outline" size="sm" className="justify-self-start" asChild>
            <Link to="/studio/console">{t("settings.open")}</Link>
          </Button>
        ) : null}
      </div>
    </div>
  );
}
